export function formatWithCommas(value: string) {
  if (!value) {
    return '';
  }
  const [intPart, decPart] = value.split('.');
  const intFormatted = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return decPart !== undefined ? `${intFormatted}.${decPart}` : intFormatted;
}
